import { makeStyles } from '@mui/styles';

export const useStylesPaper = makeStyles({
  root: {
    width: 327,
    padding: '16px 20px',
    borderRadius: 8,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1302,

    '&:focus, &:hover': {
      outline: 0,
    },

    '@media(max-width: 379px)': {
      width: 280,
    },
  },
});

export const useStylesIcon = makeStyles({
  root: {
    alignSelf: 'flex-end',
  },
});

export const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 2000,
    color: '#fff',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 900,
    fontSize: theme.fonts.sizes.font20PX,

    '@media(max-width: 379px)': {
      fontSize: theme.fonts.sizes.font18PX,
    },
  },
  subTitle: {
    marginBottom: 30,
    fontWeight: 400,
    textAlign: 'center',
    fontSize: theme.fonts.sizes.font16PX,
    color: theme.colors.light.lightSteelBlue,

    '@media(max-width: 379px)': {
      marginBottom: 20,
    },
  },
  haveAccountMessage: {
    display: 'flex',
    justifyContent: 'center',
  },
  accountText: {
    margin: '0 3px',
    fontSize: theme.fonts.sizes.font12PX,
  },
  signInText: {
    margin: '0 3px',
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font12PX,
  },
  separator: {
    margin: '0 0 16px 0',
    fontSize: theme.fonts.sizes.font12PX,
    textTransform: 'uppercase',
    fontWeight: 700,
    textAlign: 'center',
    position: 'relative',

    '&:before, &:after': {
      content: '""',
      display: 'block',
      width: '45%',
      height: 2,
      backgroundColor: theme.colors.light.ghostWhite,
      position: 'absolute',
      top: '50%',
      zIndex: 1,
      transform: 'translateY(-50%)',
    },

    '&:before': {
      left: 0,
    },

    '&:after': {
      right: 0,
    },
  },
  authProvidersButton: {
    padding: '10px 15px',
    textTransform: 'capitalize',
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font16PX,
  },
  forgotPassword: {
    marginBottom: 12,
    fontWeight: 700,
    textAlign: 'center',
    fontSize: theme.fonts.sizes.font12PX,
  },
}));
